import { Briefcase, Code2, Globe, Megaphone, ShoppingCart, Shield, Trash2, Eye, Lock } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

const audiences = [
  { icon: Megaphone, label: 'SEO Professionals' },
  { icon: Briefcase, label: 'SaaS Teams' },
  { icon: Globe, label: 'Digital Agencies' },
  { icon: ShoppingCart, label: 'E-commerce' },
  { icon: Code2, label: 'Developers' },
];

const dpdpPrinciples = [
  { icon: Eye, label: 'Public Data Only', detail: 'We analyze only publicly accessible website information' },
  { icon: Trash2, label: 'Right to Erasure', detail: 'Delete your data anytime — only anonymized accounting/tax records retained' },
  { icon: Lock, label: 'No Data Sharing', detail: 'Your analysis data is never shared with third parties' },
  { icon: Shield, label: 'DPDP Aligned', detail: 'Aligned with India\'s Digital Personal Data Protection Act, 2023' },
];

const TrustStrip = () => (
  <section className="py-10 border-y border-cv-navy/60 bg-white/50 backdrop-blur-sm">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <p className="text-center text-xs font-semibold uppercase tracking-widest text-cv-navy/40 mb-6">
          Trusted by teams who care about visibility
        </p>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-14">
          {audiences.map(({ icon: Icon, label }) => (
            <div
              key={label}
              className="flex items-center gap-2.5 text-cv-navy/60 hover:text-cv-navy transition-colors group"
            >
              <Icon className="w-5 h-5 group-hover:scale-110 transition-transform" />
              <span className="text-sm font-medium whitespace-nowrap">{label}</span>
            </div>
          ))}
        </div>
      </ScrollReveal>

      {/* DPDP Compliance Strip */}
      <ScrollReveal>
        <div className="mt-8 pt-6 border-t border-cv-navy/40">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Shield className="w-4 h-4 text-cv-navy" />
            <p className="text-center text-xs font-semibold uppercase tracking-widest text-cv-navy/40">
              Data Protection &amp; Privacy
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            {dpdpPrinciples.map(({ icon: Icon, label, detail }) => (
              <div
                key={label}
                className="flex items-center gap-2 px-3 py-2 bg-cv-teal/80 border border-cv-teal/60 rounded-lg hover:border-cv-teal/40 transition-all group relative"
                title={detail}
              >
                <Icon className="w-4 h-4 text-cv-navy flex-shrink-0" />
                <span className="text-xs font-medium text-cv-navy whitespace-nowrap">{label}</span>
              </div>
            ))}
          </div>
          <p className="text-center text-[11px] text-cv-navy/40 mt-3">
            Aligned with India's Digital Personal Data Protection Act (DPDP), 2023 — we only process publicly available website data
          </p>
        </div>
      </ScrollReveal>
    </div>
  </section>
);

export default TrustStrip;
